import { useEffect, useState } from "react";
import $api from "@/zapi-frontend/shared/api/axios";

type Token = {
  email: string;
  organizationName: string;
};

export function useVerifiedToken(token: string | null) {
  const [data, setData] = useState<Token | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const verifyToken = async (token: string) => {
    setIsLoading(true);
    try {
      const data = await $api.get<{ data: Token }>(`/auth/verify-invite?signUpToken=${token}`);
      setData(data.data.data);
    } catch {
      setError("Invalid token");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!token || token.length === 0) return;
    verifyToken(token);
  }, [token]);

  return { data, isLoading, error };
}
